import type { ConditionRangeInput } from '../conditions.types';

/** The parts of a section that decide how one of its bounds reads */
export type BoundUnits = Pick<
  ConditionRangeInput,
  'allowedDecimalPlaces' | 'endUnit' | 'startUnit'
>;

/**
 * A bound as its section renders it, ex `$17.50`. A whole bound reads bare —
 * `$5` over `$5.00` — while a fractional one is padded out so money does not
 * render as `$17.5`. A section that declares no decimal places has nothing to
 * pad to, so its bounds print as typed.
 */
export const formatBound = (bound: number, units?: BoundUnits): string => {
  const { allowedDecimalPlaces, endUnit = '', startUnit = '' } = units ?? {};

  const value =
    Number.isInteger(bound) || allowedDecimalPlaces === undefined
      ? String(bound)
      : bound.toFixed(allowedDecimalPlaces);

  return `${startUnit}${value}${endUnit}`;
};
